import React, { useEffect, useState } from "react";
import { Container, Modal, Form, } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { PDFHeader } from "../../../../../global/globalFunctions";
import { DeleteConstructionOrderApi, GenerateOrderPDF, GetConstructionOrderWithIdApi, UpdateConstructionOrderApi } from "./ConstructionOrderAction";
import { useNavigate, useLocation } from "react-router-dom";
import { showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from "@mui/icons-material/Edit";
import MaterialSize from "material-table";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from "moment";
import UpdateConstructionOrderModal from "./UpdateConstructionOrderModal";
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import Button from '@mui/material/Button';
import Select from "react-select";
import _ from 'lodash'


const ViewConstructionOrder = (props) => {
    const role = localStorage.getItem("role");
    const navigate = useNavigate();
    const location = useLocation();
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false);
    const [status, setStatus] = useState("");
    const tableRef = React.useRef();

    useEffect(() => {
        props.setHeading("View Contruction Orders");
    }, []);

    const handleEditClick = (rowData) => {
        setSelectedOrder(rowData);
        setShowUpdateModal(true);
    };
    const handleModalClose = () => {
        setShowUpdateModal(false);
        setSelectedOrder(null);
    };

    const handleUpdateStatus = (rowData) => {
        setShowUpdateStatusModal(true);
        setSelectedOrder(rowData);
    };
    const handleCloseStatusUpdateModal = () => {
        setShowUpdateStatusModal(false);
        setSelectedOrder(null);
    };

    const handleOrderUpdated = () => {
        if (tableRef.current) {
            tableRef.current.onQueryChange();
        }
    };

    const SaveUpdatedStatus = () => {
        props.UpdateConstructionOrderApi(
            selectedOrder?._id,
            { status: status },
            () => {
                showSuccessAlert("Status updated successfully");
                if (tableRef.current) {
                    tableRef.current.onQueryChange();
                }
                setShowUpdateStatusModal(false);
                setStatus("");
                setSelectedOrder(null);
            },
            (error) => {
                showErrorAlert(error);
            }
        );
    };

    let statusTypeData = [{
        id: "Pending",
        type: "Pending",
    },
    {
        id: "Processing",
        type: "Processing",
    },
    {
        id: "Completed",
        type: "Completed",
    },
    {
        id: "Cancelled",
        type: "Cancelled",
    }];
    const handleChangeStatusType = (selectedOption) => {
        setStatus(selectedOption.label);
    };
    const GetStatusTypeList = statusTypeData.map((x) => {
        let data = { value: x.id, label: x.type };
        return data;
    });

    return (
        <>
            <Container fluid>
                <MaterialSize
                    tableRef={tableRef}
                    title="View Contruction Orders"
                    columns={[
                        { title: 'S.No', field: 'sequenceNumber', editable: 'never' },
                        { title: 'Customer Name', field: 'customerDetails.name' },
                        { title: 'Order Date', field: 'date', render: (rowData) => moment(rowData.date).format("DD-MM-YYYY"), },
                        { title: 'Delivery Date', field: 'deliveryDate', render: (rowData) => moment(rowData.deliveryDate).format("DD-MM-YYYY"), },
                        { title: 'Selling Price', field: 'sellingPrice', render: (rowData) => (role === "admin" ? rowData.sellingPrice : "*****") },
                        { title: 'Status', field: 'status' },
                        { title: 'CreatedBy', field: 'userDetails.userName' },
                    ]}
                    data={(query) =>
                        new Promise((resolve, reject) => {
                            let url = `${baseURL}/construction/get-construction-orders?`;
                            url += "limit=" + query.pageSize;
                            url += "&page=" + (query.page);
                            url += "&search=" + query.search;
                            fetch(url, {
                                method: "GET",
                                headers: headers,
                            }).then((response) => response.json()).then((result) => {
                                resolve({
                                    data: result.data,
                                    page: result.page,
                                    totalCount: result.total_results,
                                });
                            });
                        })
                    }
                    options={{
                        actionsColumnIndex: -1,
                        exportButton: true,
                        exportAllData: true,
                        paging: true,
                        pageSize: 50,
                        emptyRowsWhenPaging: false,
                        pageSizeOptions: [50, 100, 150, 200],
                        headerStyle: {
                            position: "sticky",
                            top: 0,
                            color: "#00BBBB",
                            fontWeight: "550",
                            onRowAdd: "none",
                            whiteSpace: 'nowrap',
                        },
                        rowStyle: {
                            whiteSpace: 'nowrap',
                        },
                        cellStyle: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        },
                        exportPdf: (columns, data) => {
                            const unit = "pt";
                            const size = "A4";
                            const orientation = "l";
                            const doc = new jsPDF(orientation, unit, size);
                            PDFHeader(doc, "Construction Order Details");

                            const columnTitles = columns.map(columnDef => columnDef.title);
                            const pdfData = data.map((elt) => [
                                elt.sequenceNumber,
                                elt.customerDetails.name,
                                elt.date,
                                elt.deliveryDate,
                                elt.sellingPrice,
                                elt.status,
                                elt.userDetails.userName,
                            ]);
                            let content = {
                                startY: 120,
                                startX: 5,
                                head: [columnTitles],
                                body: pdfData,
                                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                                styles: { fontSize: 9 },
                                theme: "grid",
                            };

                            doc.setFontSize(11)
                            doc.setFont("Times New Roman", "Normal")
                            doc.autoTable(content);

                            doc.setProperties({ title: 'Construction Order Details' })
                            doc.output('dataurlnewwindow')
                        },
                    }}
                    editable={{
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    props.DeleteConstructionOrderApi(oldData._id);

                                    if (tableRef.current) {
                                        tableRef.current.onQueryChange();
                                    }
                                }, 600);
                            }),
                    }}
                    actions={[
                        {
                            icon: () => <ChangeCircleIcon />,
                            tooltip: "Update Status",
                            onClick: (event, rowData) => {
                                handleUpdateStatus(rowData);
                            },
                        },
                        {
                            icon: () => <EditIcon />,
                            tooltip: "Edit Order",
                            onClick: (event, rowData) => {
                                handleEditClick(rowData);
                            },
                        },
                        {
                            icon: () => <PictureAsPdfIcon />,
                            tooltip: "Generate PDF",
                            onClick: (event, rowData) => {
                                props.GenerateOrderPDF(rowData);
                            },
                        },
                        {
                            icon: () => <RemoveRedEyeIcon />,
                            tooltip: "View Detail",
                            onClick: (event, rowData) => {
                                props.GetConstructionOrderWithIdApi(rowData._id)
                                navigate(`/contruction/order/details`, { state: { from: location.pathname } })
                            },
                        },
                    ]}
                />

                {/* Update Modal */}
                <UpdateConstructionOrderModal
                    show={showUpdateModal}
                    onHide={handleModalClose}
                    orderData={selectedOrder}
                    onUpdate={handleOrderUpdated}
                />

                <Modal show={showUpdateStatusModal} onHide={handleCloseStatusUpdateModal} size="lg" centered>
                    <Modal.Header closeButton style={{ padding: '20px 24px 16px', borderBottom: '1px solid #f0f0f0' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div style={{ width: 32, height: 32, borderRadius: 8, background: '#EBF4FF', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <ChangeCircleIcon />
                            </div>
                            <div>
                                <Modal.Title style={{ fontSize: 15, fontWeight: 600, marginBottom: 2 }}>Update order status</Modal.Title>
                                <p style={{ fontSize: 12, color: '#888', margin: 0 }}>Order # {selectedOrder?.sequenceNumber || '-'}</p>
                            </div>
                        </div>
                    </Modal.Header>

                    <Modal.Body style={{ padding: '24px' }}>
                        <Form.Group>
                            <Form.Label style={{ fontSize: 14, fontWeight: 600, color: '#000000', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                New status <span style={{ color: 'red' }}>*</span>
                            </Form.Label>
                            <Select placeholder="Select a Status" onChange={handleChangeStatusType} options={GetStatusTypeList} />
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer style={{ background: '#fafafa', justifyContent: 'flex-end', gap: 8 }}>
                        <Button variant="contained" onClick={handleCloseStatusUpdateModal} size="large" style={{ background: "linear-gradient(135deg,#f43f5e,#be123c)" }} > CANCEL </Button>
                        <div >
                            {_.isEmpty(status) ? (
                                <Button variant="contained" size="large" disabled> UPDATE </Button>
                            ) : (
                                <Button variant="contained" size="large" onClick={SaveUpdatedStatus}> UPDATE </Button>
                            )}
                        </div>
                    </Modal.Footer>
                </Modal>

            </Container>
        </>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        UpdateConstructionOrderApi: (orderId, data, onSuccess, onError) => dispatch(UpdateConstructionOrderApi(orderId, data, onSuccess, onError)),
        DeleteConstructionOrderApi: (orderId) => dispatch(DeleteConstructionOrderApi(orderId)),
        GetConstructionOrderWithIdApi: (orderId) => dispatch(GetConstructionOrderWithIdApi(orderId)),
        GenerateOrderPDF: (orderData) => dispatch(GenerateOrderPDF(orderData)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingConstructionOrder: state.ConstructionOrderReducer.isFetchingConstructionOrder,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewConstructionOrder);